import { render, staticRenderFns } from "./CalibrateTMA.vue?vue&type=template&id=454540d3&"
import script from "./CalibrateTMA.vue?vue&type=script&lang=js&"
export * from "./CalibrateTMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports